interface AnchorbaseLogoProps {
    readonly width: number;
    readonly className?: string;
}

export function AnchorbaseLogo(props: AnchorbaseLogoProps) {
    return (
        <img
            src="/assets/anchorbase_logo.svg"
            alt="Anchorbase logo"
            width={props.width}
            className={props.className}
            style={{ maxWidth: props.width, height: 'auto' }}
        />
    );
}
